import React from 'react';
import { Container } from '@material-ui/core';

import css from './Section.module.css';

const Section = (props) => (
    <Container>
        <h3>{props.title}</h3>
        <div className={css.Content}>
            {props.children}
        </div>
    </Container>
);

export default Section;